import { useState, useEffect } from 'react';
import { Modal } from './index';

/**
 * Carrusel de promociones como banner publicitario
 */
function PromotionsCarousel({ items = [], autoPlayInterval = 5000 }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    if (items.length <= 1) return;
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % items.length);
    }, autoPlayInterval);
    return () => clearInterval(timer);
  }, [items.length, autoPlayInterval]);

  if (items.length === 0) return null;

  return (
    <div className="w-full overflow-hidden">
      <div className="relative rounded-xl overflow-hidden bg-[#0f3c32]/90 border border-[#CFFF33]/30">
        <div
          className="flex transition-transform duration-500 ease-out"
          style={{ transform: `translateX(-${activeIndex * 100}%)` }}
        >
          {items.map((item) => {
            const content = (
              <div className="aspect-[3/1] min-h-[120px] sm:min-h-[140px] flex items-center gap-4 p-4 sm:p-6">
                {item.imagen && (
                  <div className="flex-shrink-0 w-[70%] h-full rounded-lg overflow-hidden bg-white/10 cursor-pointer" onClick={() => { setSelectedImage(item.imagen); setIsModalOpen(true); }}>
                    <img src={item.imagen} alt={item.titulo} className="w-full h-full object-contain" />
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-white text-lg sm:text-xl mb-1">{item.titulo}</h3>
                  {item.descripcion && (
                    <p className="text-white/90 text-sm line-clamp-2">{item.descripcion}</p>
                  )}
                  {item.url && (
                    <span className="inline-block mt-2 text-[#CFFF33] font-medium text-sm">
                      Ver más →
                    </span>
                  )}
                </div>
              </div>
            );
            return (
              <div key={item.id} className="w-full flex-shrink-0">
                {item.url ? (
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block hover:opacity-95 transition-opacity"
                  >
                    {content}
                  </a>
                ) : (
                  <div className="block">{content}</div>
                )}
              </div>
            );
          })}
        </div>

        {items.length > 1 && (
          <>
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2">
              {items.map((_, idx) => (
                <button
                  key={idx}
                  type="button"
                  onClick={() => setActiveIndex(idx)}
                  className={`w-2 h-2 rounded-full transition-colors ${
                    idx === activeIndex ? 'bg-[#CFFF33]' : 'bg-white/40 hover:bg-white/60'
                  }`}
                  aria-label={`Ir a promoción ${idx + 1}`}
                />
              ))}
            </div>
            <button
              type="button"
              onClick={() => setActiveIndex((prev) => (prev - 1 + items.length) % items.length)}
              className="absolute left-2 top-1/2 -translate-y-1/2 w-90 h-auto rounded-full bg-black/50 hover:bg-black/70 text-white flex items-center justify-center"
              aria-label="Anterior"
            >
              ‹
            </button>
            <button
              type="button"
              onClick={() => setActiveIndex((prev) => (prev + 1) % items.length)}
              className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/50 hover:bg-black/70 text-white flex items-center justify-center"
              aria-label="Siguiente"
            >
              ›
            </button>
          </>
        )}
      </div>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title="Imagen completa" size="xl">
        {selectedImage && <img src={selectedImage} alt="Imagen completa" className="w-full h-auto" />}
      </Modal>
    </div>
  );
}

export default PromotionsCarousel;
